import type { Translation } from './en'

const zh: Translation = {
  nav: {
    badge: '工作室',
    gallery: '场景广场',
    login: '登录 / 注册',
    logout: '登出',
    debugMode: '调试模式',
  },
  gallery: {
    heroTitle: '把数据变成让人停下来刷的视频。',
    heroHighlight: '停下来刷',
    heroSubtitle: '选场景、改数据、导出各平台通用的 MP4。',
    enter: '进入',
    myProjects: '我的项目',
    noProjects: '还没有项目。选一个场景开始创作，在工作室点💾保存就会出现在这里。',
    scenesTitle: '场景',
  },
  auth: {
    loginTitle: '登录',
    registerTitle: '注册',
    loginTab: '登录',
    registerTab: '注册',
    nickname: '昵称',
    nicknamePh: '你的昵称',
    email: '邮箱',
    emailPh: 'you@example.com',
    password: '密码',
    passwordMin8: '密码（至少 8 位）',
    emailCode: '邮箱验证码',
    sendCode: '发送验证码',
    codePh: '6 位验证码',
    loginBtn: '登录',
    registerBtn: '注册并登录',
    orEmail: '或邮箱注册 / 登录',
    googleOnlyHint: '使用 Google 账号继续，开启你的创作之旅',
    googleFail: 'Google 登录失败',
    sendFail: '发送失败',
    opFail: '操作失败',
  },
  editorPanel: {
    bgColor: '背景色',
    resetBg: '重置默认背景',
    data: '数据',
    exportJson: '⬇ 导出 JSON',
    importJson: '⬆ 导入 JSON',
    undo: '撤销 (Ctrl+Z)',
    redo: '重做 (Ctrl+Shift+Z)',
    aiFill: '✨ AI 填充',
    aiLoginRequired: 'AI 填充需要登录后使用',
    aiOverwriteConfirm: 'AI 填充会用生成内容覆盖当前数据，确定继续吗？',
    aiGenerating: '生成中… {{count}} 字',
    aiFail: 'AI 填充失败',
    close: '关闭编辑器',
    jsonParseFail: 'JSON 解析失败，请检查文件格式',
  },
  common: {
    back: '返回',
    undo: '撤销',
    redo: '重做',
    regenerate: '换一批',
    export: '导出',
    play: '播放',
    pause: '暂停',
    loading: '加载中…',
    save: '保存',
    cancel: '取消',
    close: '关闭',
    comingSoon: '即将推出',
  },
  studio: {
    scenes: '场景',
    preview: '预览',
    editor: '编辑器',
    resolution: '1080×1920 · 9:16',
    saved: '✓ 已保存',
    saveTitle: '保存到我的项目',
    saveTitlePrompt: '项目标题',
    saveFail: '保存失败',
  },
  lang: {
    toggle: 'EN',
    title: 'Switch language',
  },
  export: {
    title: '导出视频',
    platform: '平台',
    audio: '音效',
    audioNone: '无',
    watermark: '水印',
    watermarkPlaceholder: '@你的账号',
    position: '位置',
    opacity: '透明度',
    render: '开始导出',
    rendering: '渲染中…',
    failed: '导出失败',
    downloading: '准备下载…',
    done: '导出完成',
    browserForce: '强制浏览器端导出（调试）',
    serverPath: '服务端渲染',
    browserPath: '浏览器导出',
  },
  feedback: {
    button: '反馈',
    title: '反馈',
    hint: '遇到问题、想要的功能、或任何想法——告诉我们。',
    placeholder: '写下你的反馈…',
    contactPh: '联系方式（选填，方便我们回复）',
    submit: '提交',
    sending: '提交中…',
    sent: '已收到，感谢！',
    fail: '提交失败，请稍后再试',
  },
  toast: {
    generating: '正在生成新内容…',
    regenerated: '已生成新内容',
    undone: '已撤销',
    redone: '已重做',
    nothingToUndo: '没有可撤销的操作',
    nothingToRedo: '没有可重做的操作',
  },
  editor: {
    // 通用
    title: '标题',
    valueFormat: '数值格式（前缀 / 后缀 / 小数位）',
    valuePrefixPh: '前缀 $',
    valueSuffixPh: '后缀 T/亿/%',
    timeline: '时间线',
    timelineCount: '时间线（{{count}} 帧）',
    timelineHint: '每帧 = 一个年份快照，含若干对比项；导出按时序竞速',
    frame: '帧',
    item: '项',
    deleteFrame: '删除帧',
    deleteItem: '删除项',
    compareItem: '对比项',
    name: '名称',
    namePh: '名称',
    value: '数值',
    valuePh: '值',
    desc: '描述',
    descPh: '描述',
    label: '标签',
    labelPh: '名称',
    color: '颜色',
    emoji: 'Emoji',
    metric: '指标',
    metricPh: '指标',
    // ranking
    items: '条目',
    itemsCount: '条目（{{count}}）',
    // vs
    left: '左侧',
    right: '右侧',
    // quote
    quote: '金句',
    author: '作者',
    background: '背景',
    // map
    journeyTitle: '行程标题',
    subtitle: '副标题',
    routeTheme: '路线主题',
    mapRegion: '地图范围',
    checkpointsCount: '途经点（{{count}}）',
    city: '城市',
    cityPh: '城市',
    // news
    category: '分类',
    headlinesCount: '新闻（{{count}}）',
    headline: '标题',
    headlinePh: '标题',
    source: '来源',
    sourcePh: '来源',
    time: '时间',
    timePh: '时间',
    news: '新闻',
    // wrapped
    year: '年份',
    statsCount: '统计（{{count}}）',
    stat: '统计项',
    tag: '标签',
    tagPh: '标签',
    // chat
    storyTitle: '故事标题',
    participantsCount: '参与者（{{count}}）',
    participant: '参与者',
    participantN: '参与者 {{n}}',
    participantEmptyHint: '（先加参与者）',
    messagesCount: '消息（{{count}}）',
    messagesHint: 'sender 选择参与者；导出按顺序逐条弹出',
    sender: '发送者',
    text: '文本',
    textPh: '消息内容',
    timePlaceholder: '时间（如 14:32）',
    message: '消息',
  },
}

export default zh
